"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jquery_1 = __importDefault(require("jquery"));

var PropertyUIControl_1 = __importDefault(require("./internal/PropertyUIControl"));

var StringResources_1 = __importDefault(require("../nls/StringResources"));

var CurrentConditionalPalette =
/** @class */
function () {
  function CurrentConditionalPalette(options) {
    if (options === void 0) {
      options = {};
    }

    this.$el = jquery_1.default('<div/>');
    this.parentNode = options.parentNode;
    this.onCloseCb = options.onCloseCb;
    this.uiContext = options.uiContext;
  }

  CurrentConditionalPalette.prototype.render = function () {
    var _this = this;

    this._deletePropertyUIControl();

    var propertySpec = this._getPropertySpec();

    this._propertyUIControl = new PropertyUIControl_1.default(propertySpec);
    return this._propertyUIControl.render().then(function () {
      _this._propertyUIControl.focus();

      return _this._propertyUIControl;
    });
  };
  /**
   * Call by PropertiesManager.closeChild to clean up the mounted component
   */


  CurrentConditionalPalette.prototype.remove = function () {
    this.uiContext.removeUiConditionalColorPanel();
  };

  CurrentConditionalPalette.prototype._deletePropertyUIControl = function () {
    if (this._propertyUIControl) {
      this._propertyUIControl.remove();

      this.$el.empty();
      this._propertyUIControl = null; // The Child Panel was manually close by the user from the UI Top Back Banner
      // so set the measure data item to undefined

      this.uiContext.setMeasureDataItem(undefined);
    }
  };

  CurrentConditionalPalette.prototype._getPropertySpec = function () {
    var properties = [];
    properties.push(this._createConditionalColoBannerSpec());
    properties.push(this._createCurrentConditionalColorSpec());
    return {
      el: this.$el,
      items: properties,
      ariaLabel: properties[0].value,
      primaryUIControl: true,
      paletteService: this.uiContext.getPaletteService()
    };
  };

  CurrentConditionalPalette.prototype._createConditionalColoBannerSpec = function () {
    var _this = this;

    var cfState = this.uiContext.getConditionalFormattingState();
    var mstForUIPanels = cfState.getMstForUIPanels();
    return {
      type: 'Banner',
      value: StringResources_1.default.get('conditionalColor') + ': ' + mstForUIPanels.getDataItemLabel(),
      name: 'changeConditionalColorBanner',
      id: 'changeConditionalColorBanner',
      centerLabel: true,
      onClose: function onClose() {
        // Get here when the user manually select the Back button on the top
        // Properties Panel Banner to close the child panel
        _this._deletePropertyUIControl();

        if (_this.onCloseCb) {
          _this.onCloseCb();
        }
      },
      backButton: true
    };
  };

  CurrentConditionalPalette.prototype._createCurrentConditionalColorSpec = function () {
    return {
      id: 'currentConditionalColorPanel',
      module: 'dashboard-analytics/features/content/conditionalFormatting/ConditionalFormatting',
      moduleClass: 'ConditionalColorPanel',
      uiContext: this.uiContext
    };
  };

  return CurrentConditionalPalette;
}();

exports.default = CurrentConditionalPalette;
